(function () {
  if (window.__productUpsellFetchPatched) return;
  window.__productUpsellFetchPatched = true;

  const instances = new Set();
  window.__productUpsellInstances = instances;

  const originalFetch = window.fetch;
  let __lastCartAddTime = 0;

  // =========================
  // INSTANCE DISCOVERY FUNCTION (EXPORTED)
  // =========================
  window.discoverInstances = function () {
    document.querySelectorAll('upsell-product').forEach((el) => {
      if (!instances.has(el) && el.__isUpSellComponent) {
        instances.add(el);
        // console.log('[upsell] Discovered instance via scan:', el);
      }
    });
  };

  // =========================
  // MAIN ATC DETECTOR (FIXED)
  // =========================
  window.__mainATCTriggered = false;

  document.addEventListener('click', (e) => {
      const btn = e.target.closest(
        '.product-form__buttons button[type="submit"], ' +
        '.product-form__submit, ' +
        '.shopify-payment-button'
      );

      if (!btn) return;

      window.__mainATCTriggered = true;
      // console.log('[upsell] ATC click matched', btn);

      setTimeout(() => {
        window.__mainATCTriggered = false;
      }, 1200);
    },
    true
  );

  // =========================
  // FETCH WRAPPER
  // =========================
  window.fetch = function (input, init = {}) {
    const url = typeof input === 'string' ? input : input?.url || '';
    
    // Scan for newly injected upsell instances right before processing
    window.discoverInstances();
    
    const result = originalFetch.apply(this, arguments);

    const isCartAdd = url.includes('/cart/add');
    const isMainProductATC = window.__mainATCTriggered;

    const headers = init.headers || {};
    const isUpsellRequest =
      headers['x-upsell-request'] === 'true' ||
      headers['X-Upsell-Request'] === 'true';

      // console.log({
      //  url,
      //  isCartAdd,
      //  isMainProductATC,
      //  isUpsellRequest,
      //  instances: window.__productUpsellInstances?.size
      // });

    if (isCartAdd && isMainProductATC && !isUpsellRequest) {
      // console.log('MAIN PRODUCT CART ADD DETECTED');
      const now = Date.now();
      if (now - __lastCartAddTime < 800) return result;

      result
        .then((res) => res.clone().json())
        .then((data) => {
          if (!data.status) {
            __lastCartAddTime = Date.now();
            
            //  Use stored states instead of DOM elements
            // console.log('[upsell] Stored states:', window.__upsellStates);
            
            // Try DOM elements first (for PDP)
            instances.forEach((el) => {
              if (el && el.addUpsellItem && el.checkbox?.checked) {
                // console.log('[upsell] Adding from DOM element');
                el.addUpsellItem();
              }
            });
            
            // Then try stored states (for Quick Add where DOM was removed)
            if (window.__upsellStates && window.__upsellStates.size > 0) {
              window.__upsellStates.forEach((state) => {
                if (state.element && state.element.checkbox?.checked) {
                  // console.log('[upsell] Adding from stored state');
                  state.element.addUpsellItem();
                } else if (!state.element && state.checked) {
                  // Fallback: the element was removed, but state says it should be added
                  // console.log('[upsell] Element removed but state says add upsell');
                  fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'x-upsell-request': 'true'
                    },
                    body: JSON.stringify({
                      items: [{ id: parseInt(state.variantId, 10), quantity: 1 }]
                    })
                  })
                    .then((r) => r.json())
                    .then(() => {
                      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upsell-product' });
                      }
                    })
                    .catch((err) => console.error('[upsell] Fallback upsell failed:', err));
                }
              });
            }
          }
        })
        .catch(() => {});
    }

    return result;
  };
})();

// =========================
// UPSSELL COMPONENT
// =========================
if (!customElements.get('upsell-product')) {
  class ProductUpsell extends HTMLElement {
    connectedCallback() {
      // Mark this as a valid component immediately
      this.__isUpSellComponent = true;

      this.variants = JSON.parse(this.dataset.variants || '[]');
      this.discount = parseInt(this.dataset.discount, 10) || 0;
      this.mainPrice = parseInt(this.dataset.mainPrice, 10) || 0;
      this.preloadVariantImages();
     
      this.upsellProductId = this.dataset.productId;  // ← ADD THIS
      const upsellState = {
        element: this,
        checked: false,
        variantId: this.dataset.variantId,
        productId: this.upsellProductId
      };
      window.__productUpsellInstances?.add(this);
      window.__upsellStates = window.__upsellStates || new Map();
      window.__upsellStates.set(this.upsellProductId, upsellState); 

      // console.log('[upsell] Component connected, added to instances. Total:', window.__productUpsellInstances?.size);


      this.checkbox = this.querySelector('.upsell-product__checkbox');
      this.select = this.querySelector('.upsell-product__variant-select');
      this.image = this.querySelector('.upsell-product__image img');
      this.salePrice = this.querySelector('.upsell-product__sale-price');
      this.comparePrice = this.querySelector('.upsell-product__compare-price');
      this.bundleTotalEl = this.querySelector('[data-bundle-total]');
      this.bundleSeparatelyEl = this.querySelector('[data-bundle-separately]');

      this._isSendingUpsell = false;
      this._upsellProcessed = false;

      //  Add to instances Set immediately on connect
      window.__productUpsellInstances?.add(this);
      // console.log('[upsell] Component connected, added to instances. Total:', window.__productUpsellInstances?.size);

      this.checkbox?.addEventListener('change', () => this.onToggle());
      this.select?.addEventListener('change', () => this.onVariantChange());

      this.onToggle();
      this.updateBundleTotal();
    }

    disconnectedCallback() {
     // Don't remove immediately - the modal closing shouldn't clear instances
      // The instance might still be needed for pending ATC requests
      // Only remove after a delay to ensure fetch completes
      setTimeout(() => {
        window.__productUpsellInstances?.delete(this);
        console.log('[upsell] Component cleaned up after delay. Remaining:', window.__productUpsellInstances?.size);
      }, 2000);
    }

    // =========================
    // ADD UPSELL ITEM
    // =========================
    addUpsellItem() {
      console.log('[upsell] addUpsellItem called', this);
      if (this._upsellProcessed) return;
      this._upsellProcessed = true;

      setTimeout(() => {
        this._upsellProcessed = false;
      }, 5000);

      if (!this.checkbox?.checked) return;

      const variantId = this.select
        ? this.select.value
        : this.dataset.variantId;

      if (!variantId) return;

      this._isSendingUpsell = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-upsell-request': 'true'
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }]
        })
      })
        .then((r) => r.json())
        .then(() => {
          this._isSendingUpsell = false;

          if (
            typeof publish === 'function' &&
            typeof PUB_SUB_EVENTS !== 'undefined'
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'upsell-product'
            });
          }
        })
        .catch((err) => {
          this._isSendingUpsell = false;
          console.error('[upsell] Upsell add-to-cart failed:', err);
        });
    }

    // =========================
    // TOGGLE
    // =========================
    onToggle() {
      this.dataset.checked = this.checkbox?.checked;
      
      // Update stored state when checkbox changes
      if (window.__upsellStates && this.upsellProductId) {
        const state = window.__upsellStates.get(this.upsellProductId);
        if (state) {
          state.checked = this.checkbox?.checked;
        }
      }
      
      this.updateBundleTotal();
    }

    // =========================
    // VARIANT CHANGE
    // =========================
preloadVariantImages() {
  this.variants.forEach((variant) => {
    const src = variant.featured_image?.src;
    if (!src) return;

    try {
      const imageUrl = new URL(src, window.location.origin);
      imageUrl.searchParams.set('width', '200');

      const img = new Image();
      img.src = imageUrl.toString();
    } catch (error) {
      console.warn('[upsell] Invalid image URL:', src);
    }
  });
}
    onVariantChange() {
      const id = parseInt(this.select.value, 10);
      const variant = this.variants.find((v) => v.id === id);
      if (!variant) return;

      if (this.image && variant.featured_image) {
        console.log('variant.featured_image.src', variant.featured_image.src)
       const imageUrl = `${variant.featured_image.src}&width=200`;

        this.image.src = imageUrl;
        this.image.removeAttribute('srcset');
        this.image.alt = variant.featured_image.alt || variant.title;
      }

      const price =
        this.discount > 0
          ? Math.round((variant.price * (100 - this.discount)) / 100)
          : variant.price;

      if (this.salePrice) {
        this.salePrice.textContent = this.formatMoney(price);
      }

      if (this.comparePrice) {
        if (this.discount > 0) {
          this.comparePrice.textContent = this.formatMoney(variant.price);
          this.comparePrice.hidden = false;
        } else {
          this.comparePrice.hidden = true;
        }
      }

      this.updateBundleTotal();
    }

    // =========================
    // BUNDLE TOTAL
    // =========================
    updateBundleTotal() {
      if (!this.bundleTotalEl) return;

      const id = this.select
        ? parseInt(this.select.value, 10)
        : parseInt(this.dataset.variantId, 10);

      const variant = this.variants.find((v) => v.id === id);

      const full = variant ? variant.price : 0;

      const discounted =
        this.discount > 0
          ? Math.round((full * (100 - this.discount)) / 100)
          : full;

      const isChecked = this.checkbox?.checked;

      const total = this.mainPrice + (isChecked ? discounted : 0);
      const separately = this.mainPrice + (isChecked ? full : 0);

      this.bundleTotalEl.textContent = this.formatMoney(total);

      if (this.bundleSeparatelyEl) {
        if (isChecked && this.discount > 0) {
          this.bundleSeparatelyEl.textContent =
            `vs ${this.formatMoney(separately)} separately`;
          this.bundleSeparatelyEl.hidden = false;
        } else {
          this.bundleSeparatelyEl.hidden = true;
        }
      }
    }

    // =========================
    // MONEY FORMAT (SHOPIFY SAFE)
    // =========================
    formatMoney(cents) {
      if (window.Shopify?.formatMoney && window.Shopify.money_format) {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      }

      return `$${(cents / 100).toFixed(2)}`;
    }
  }

  customElements.define('upsell-product', ProductUpsell);
}

// After page fully loads, scan for any upsell instances
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    // console.log('[upsell] Scanning for instances on DOMContentLoaded');
    window.discoverInstances();
  });
} else {
  // console.log('[upsell] Scanning for instances (already loaded)');
  window.discoverInstances();
}